// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pro .tips[data-v-b1a4587c] {\n  height: 50px;\n  line-height: 50px;\n  color: #999;\n  font-size: 12px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n.pro .btn-box[data-v-b1a4587c] {\n  padding-bottom: 20px;\n}", ""]);
// Exports
module.exports = exports;
